import { assetUrl } from '../../lib/assetUrl';

/**
 * @param {{ member: import('../../data/teamMembers').TeamMember }} props
 */
export default function TeamCard({ member }) {
  const { name, title, photo, description } = member;

  return (
    <li className="team-card">
      <div className="team-card__media">
        <img src={assetUrl(photo)} alt={name} loading="lazy" />
      </div>
      <div className="team-card__body">
        <h3 className="team-card__name">{name}</h3>
        <p className="team-card__role">{title}</p>
        <ul className="team-card__notes">
          {description.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </div>
    </li>
  );
}
